export default function selectedChannel(state = false, action) {
  switch (action.type) {
    case 'select_channel': 
      return action.item;
    default:
      return state;
  }
}